import React from 'react';

import { BreadcrumbsItem } from './BreadcrumbsItem';

export type CheckoutBreadcrumb = 'allProducts' | 'mySelection' | 'checkout';

export interface Breadcrumb {
  to: string;
  isSelected: boolean;
  isActive?: boolean;
  label: string;
  dataTestId?: string;
  onClick?: VoidFunction;
}

export interface Props {
  title: string;
  steps: Breadcrumb[];
}

export const Breadcrumbs = ({ title, steps }: Props) => {
  return (
    <nav className="align-center flex h-8 flex-shrink-0 items-center">
      <h2 className="sr-only">{title}</h2>
      <ul className="flex items-center gap-4">
        {steps.map(({ to, isSelected, isActive = true, label, dataTestId, onClick }, index) => (
          <React.Fragment key={to}>
            <BreadcrumbsItem to={to} isActive={isActive} label={label} onClick={onClick} dataTestId={dataTestId} isSelected={isSelected} />
            {index !== steps.length - 1 && <div className="size-1 rounded-full bg-neutral-60" />}
          </React.Fragment>
        ))}
      </ul>
    </nav>
  );
};
